import { Injectable, signal, WritableSignal } from '@angular/core';
import { TableInstance } from '@components/base-components/table-components/models/table-instance.model';

@Injectable({
  providedIn: 'root',
})
export class TableConductorService {
  activeTable: WritableSignal<TableInstance | null> = signal(null);

  tables: WritableSignal<Record<string, TableInstance>> = signal({});

  addTable(name: string, table: TableInstance): void {
    this.tables.update((prev) => ({
      ...prev,
      [name]: table,
    }));
  }

  removeTable(name: string): void {
    this.tables.update((prev) => {
      const next = { ...prev };
      delete next[name];
      return next;
    });

    if (this.activeTable() === this.tables()[name]) {
      this.activeTable.set(null);
    }
  }

  updateTable(name: string): void {
    const table = this.tables()[name];
    if (table) {
      table.baseTableService.getData();
    }
  }

  getTable(name: string): TableInstance | null {
    return this.tables()[name] ?? null;
  }
}
